import { IIncident, ServiceState } from '../../rz-status_models';
import { useFilter } from '../contextProviders/FilterContext';
import IncidentElement from "../listview/Incident";

export default function({data, empty}:{data: IIncident[], empty: boolean}) {
  const {setFilter} = useFilter();

	if(data && !empty) {
		if(data.length == 0) {
			return <div id="overview" className="empty">
			<h2>Keine Ergebnisse für die eingestellten Filter</h2>
			<p>Passen Sie Ihre Filter an, um ein Ergebnis zu erhalten.</p>
			<button onClick={() => setFilter([ServiceState.Available, ServiceState.Maintanance, ServiceState.Limited, ServiceState.Outage])}>Filter zurücksetzen</button>
			</div>
		}
		return <table className="incidents" aria-label="Aktuelle Störungen und Ausfälle">
			<thead>
				<tr>
					<th className="application">Anwendung</th>
					<th className="date start">Beginn</th>
					<th className="date end">Ende</th>
					<th className="state">Verfügbarkeit</th>
				</tr>
			</thead>
			<tbody>
				{data.map((incident, i) => <IncidentElement key={i} incident={incident}/>)}
			</tbody>
		</table>
	}

	else {
		return <div id="overview" className="empty">
		<h3>Aktuell keine Störungen vorhanden</h3>
		</div>
	}
}